export default __webpack_public_path__ + "static/media/hero_bg.b2037e15.svg";